// The "Forgot password?" email's link (SM-968).
import { createFileRoute } from "@tanstack/react-router";
import { PasswordLinkPage } from "@/components/auth/PasswordLinkPage";

export const Route = createFileRoute("/reset-password")({
  validateSearch: (search: Record<string, unknown>): { token?: string } => ({
    token: typeof search.token === "string" && search.token !== "" ? search.token : undefined,
  }),
  component: ResetPasswordPage,
});

function ResetPasswordPage() {
  const { token } = Route.useSearch();
  return <PasswordLinkPage purpose="reset" token={token} />;
}
